
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import "./horizonAdmin.css";
import "./submenu.css";
import "./formsSidebar.css";
import FormsSidebarMenu from "./FormsSidebarMenu";
import { isFormPath } from "./formsMenuTree";

import { getStoredRole } from "../../utils/rolePermissions";
const staticMenu = [
  { icon: "fa-solid fa-chart-line", label: "Main Dashboard", path: "/admin/dashboard" },
  {
    icon: "fa-solid fa-gear",
    label: "Settings",
    isDropdown: true,
    path: "/admin/settings",
    subMenu: [
      { icon: "fa-solid fa-users", label: "App Users", path: "/admin/app-users" },
      { icon: "fa-solid fa-id-badge", label: "Director", path: "/admin/directors" },
      { icon: "fa-solid fa-user-shield", label: "SubAdmins", path: "/admin/sub-admins" },
      { icon: "fa-solid fa-user-tie", label: "Managers", path: "/admin/managers" },
      { icon: "fa-solid fa-key", label: "Secret Key Manager", path: "/admin/secret-key" },
      { icon: "fa-solid fa-user-lock", label: "Roles & Permissions", path: "/admin/roles-permissions" },
    ],
  },
  { icon: "fa-solid fa-map-marker-alt", label: "Sites", path: "/admin/sites" },
  { icon: "fa-solid fa-cloud-arrow-up", label: "SharePoint Sync", path: "/admin/sharepoint-sync" },
  {
    icon: "fa-solid fa-qrcode",
    label: "Asset Management",
    isDropdown: true,
    path: "/admin/asset-management",
    subMenu: [
      { icon: "fa-solid fa-home", label: "Overview", path: "/admin/asset-management" },
      { icon: "fa-solid fa-tags", label: "QR Labels", path: "/admin/asset-management/qr-labels" },
      { icon: "fa-solid fa-boxes-stacked", label: "Assets", path: "/admin/asset-management/assets" },
      { icon: "fa-solid fa-triangle-exclamation", label: "Fault Tickets", path: "/admin/asset-management/tickets" },
    ],
  },
  {
    icon: "fa-solid fa-folder",
    label: "Forms",
    isDropdown: true,
    isFormsDropdown: true,
    subMenu: [],
  },
  // { icon: "fa-solid fa-wand-magic-sparkles", label: "Form Builder", path: "/admin/form-builder" },
  // {
  //   icon: "fa-solid fa-file-circle-plus",
  //   label: "Dynamic Forms",
  //   isDropdown: true,
  //   isDynamicDropdown: true,
  //   path: "/admin/dynamic-forms",
  //   subMenu: [] // Initialize with empty array
  // },
  // File Upload section
  // { 
  //   icon: "fa-solid fa-cloud-arrow-up", 
  //   label: "File Upload", 
  //   path: "/admin/file-upload",
  //   badge: "New"
  // },
  // Calendar Data dropdown
  {
    icon: "fa-solid fa-database",
    label: "Calendar View",
    isDropdown: true,
    isCalendarDataDropdown: true,
    path: "/admin/calendar-data",
    subMenu: [] // Initialize with empty array
  },
  // Team menu
  { 
    icon: "fa-solid fa-users", 
    label: "Team", 
    path: "/admin/team" 
  },
  // Fatigue Management (HSE rules, work sheets, shifts, exceedance forms)
  {
    icon: "fa-solid fa-clipboard-list",
    label: "Fatigue Management",
    isDropdown: true,
    path: "/admin/fatigue",
    subMenu: [
      { icon: "fa-solid fa-home", label: "Overview", path: "/admin/fatigue" },
      { icon: "fa-solid fa-file-alt", label: "Work Sheets", path: "/admin/fatigue/work-sheets" },
      { icon: "fa-solid fa-clock", label: "Shift Entry", path: "/admin/fatigue/shifts" },
      { icon: "fa-solid fa-exclamation-triangle", label: "Exceedance Forms", path: "/admin/fatigue/exceedance-forms" },
      { icon: "fa-solid fa-file-signature", label: "D-Fatigue Management Plan", path: "/admin/fatigue/d-fatigue-management-plan" },
      { icon: "fa-solid fa-chart-bar", label: "Fatigue Rules List", path: "/admin/fatigue/fatigue-rules-list" },
      { icon: "fa-solid fa-file-invoice-dollar", label: "Billing Report", path: "/admin/fatigue/billing-report" },
    ],
  },
  // Southeastern dropdown menu
  {
    icon: "fa-solid fa-bolt",
    label: "Southeastern",
    isDropdown: true,
    subMenu: [
      { icon: "fa-solid fa-file", label: "Service Request", path: "/admin/southeastern/entry-data" },
      // { icon: "fa-solid fa-file", label: "Outstanding Call", path: "/admin/southeastern/outstanding-call" },
      // { icon: "fa-solid fa-file", label: "Outstanding Quotes", path: "/admin/southeastern/outstanding-quotes" },
      // { icon: "fa-solid fa-file", label: "Return Visit", path: "/admin/southeastern/return-visit" },
      // { icon: "fa-solid fa-file", label: "Outstanding PPMs", path: "/admin/southeastern/outstanding-ppms" },
      { icon: "fa-solid fa-plus", label: "New Entry", path: "/admin/southeastern/new-entry" }
    ]
  },
  // UKPN dropdown menu
  { 
    icon: "fa-solid fa-hard-hat", 
    label: "UKPN", 
    isDropdown: true,
    subMenu: [
      { icon: "fa-solid fa-file", label: "Service Request", path: "/admin/ukpn/entry-data" },
      // { icon: "fa-solid fa-file", label: "Sites Being Upgraded", path: "/admin/ukpn/sites-being-upgraded" },
      { icon: "fa-solid fa-plus", label: "New Entry", path: "/admin/ukpn/new-entry" }
    ]
  },
  { icon: "fa-solid fa-mobile-screen-button", label: "App update", path: "/admin/app-update" },
  // { icon: "fa-solid fa-user", label: "Profile", path: "/admin/profile" },
  // { icon: "fa-solid fa-sign-in", label: "Sign In", path: "/admin/signin" },
];

// Get current user role from localStorage (admin | subAdmin | manager | engineer).
// Deny by default: an unknown/missing role must not fall through to "admin".
function getRoleFromStorage() {
  return getStoredRole();
}

function getFormErrorLogsEnabled() {
  try {
    return localStorage.getItem("formErrorLogsEnabled") === "true";
  } catch {
    return false;
  }
}

// Filter menu by role: admin sees all; subAdmin can see Settings but not SubAdmins entry.
function getMenuForRole(menu, role) {
  if (!menu || !Array.isArray(menu)) return menu;
  // Engineers get the forms tree and nothing else - no dashboard, no settings,
  // no fatigue, no logs.
  if (String(role).toLowerCase() === "engineer") {
    return menu.filter((item) => item.isFormsDropdown);
  }
  let filtered = menu.filter((item) => {
    if (item.label === "Sites") return true; // Sites visible by every role - never hide
    if (item.label === "App update") return role === "admin";
    // The sync queue endpoint is admin/subAdmin only - do not offer a link
    // that would bounce a manager straight back out.
    if (item.label === "SharePoint Sync") return role === "admin" || role === "subAdmin";
    if (item.label === "Settings" && role === "manager") return false;
    if (role === "subAdmin" && item.label === "SubAdmins") return false;
    if (role === "manager" && (item.label === "SubAdmins" || item.label === "Managers" || item.label === "Director")) return false;
    return true;
  });
  if (role === "admin") return filtered;
  filtered = filtered.map((item) => {
    if (!item?.isDropdown || !Array.isArray(item.subMenu)) return item;
    const subMenu = item.subMenu.filter((sub) => {
      if (item.label !== "Settings") return true;
      if (role === "subAdmin") return sub.label !== "SubAdmins" && sub.label !== "Director";
      if (role === "manager") return false;
      return true;
    });
    return { ...item, subMenu };
  }).filter((item) => !item?.isDropdown || item.isFormsDropdown || (item.subMenu && item.subMenu.length));
  return filtered;
}

function withFeatureMenus(menu, role) {
  const filtered = getMenuForRole(menu, role).filter(
    (item) => item.path !== "/admin/form-error-log" && item.path !== "/admin/api-forms-logs"
  );
  if (role !== "admin") return filtered;
  const next = [...filtered];
  if (getFormErrorLogsEnabled()) {
    next.push({ icon: "fa-solid fa-bug", label: "Form Error Logs", path: "/admin/form-error-log" });
    next.push({ icon: "fa-solid fa-server", label: "Api Error Logs", path: "/admin/api-forms-logs" });
  }
  return next;
}

export default function AdminSidebar({ collapsed = false, onToggle }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState('');
  const [dynamicForms, setDynamicForms] = useState([]);
  const [calendarFiles, setCalendarFiles] = useState([]);
  const [menu, setMenu] = useState(() => withFeatureMenus(staticMenu, getRoleFromStorage()));

  // Fetch dynamic forms and calendar files
  useEffect(() => {
    const role = getRoleFromStorage();

    const fetchDynamicForms = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        const response = await axios.get(
          `${baseUrl}/api/dynamic-forms`,
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
        if (response.data.success) {
          const forms = response.data.data;
          setDynamicForms(forms);
          // Find the Dynamic Forms menu item and update its submenu
          const updatedMenu = staticMenu.map(item => {
            if (item.isDynamicDropdown) {
              return {
                ...item,
                subMenu: forms.map(form => ({
                  icon: "fa-regular fa-file-lines",
                  label: form.formName,
                  path: `/admin/dynamic-forms/${form.formName}`
                }))
              };
            }
            return item;
          });
          setMenu(withFeatureMenus(updatedMenu, role));
        }
      } catch (error) {
        console.error('Failed to fetch dynamic forms:', error);
      }
    };

    const fetchCalendarFiles = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
        const response = await axios.get(
          `${baseUrl}/api/excel-data/calendar/files`,
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
          }
        );
        if (response.data.success) {
          const files = response.data.data || [];
          setCalendarFiles(files);
          // Find the Calendar Data menu item and update its submenu
          const updatedMenu = staticMenu.map(item => {
            if (item.isCalendarDataDropdown) {
              return {
                ...item,
                subMenu: [
                  // Static Southeastern menu item
                  {
                    icon: "fa-solid fa-bolt",
                    label: "Southeastern",
                    path: "/admin/calendar/Southeastern"
                  },
                  // Static UKPN menu item
                  {
                    icon: "fa-solid fa-hard-hat",
                    label: "UKPN",
                    path: "/admin/calendar/UKPN"
                  },
                  // Dynamic calendar files
                  ...(Array.isArray(files) ? files.map(file => {
                    // Clean filename - remove .xlsx extension, year suffixes, and replace spaces with hyphens
                    const originalFileName = file.originalName || file.fileName || '';
                    const cleanFileName = originalFileName
                      .replace(/\.xlsx$/i, '')
                      .replace(/[-_]*\d{4}[-_]*$/, '') // Remove year suffixes like -2025, ---2025, _2025
                      .replace(/\s+/g, '-')
                      .replace(/-+$/, ''); // Remove trailing hyphens

                    return {
                      icon: "fa-solid fa-file-excel",
                      label: file.originalName || file.fileName,
                      path: `/admin/calendar/${cleanFileName}`,
                      badge: `${file.totalRows || 0} rows`
                    };
                  }) : [])
                ]
              };
            }
            return item;
          });
          setMenu(withFeatureMenus(updatedMenu, role));
        }
      } catch (error) {
        console.error('Failed to fetch calendar files:', error);
      }
    };

    // Engineers have no dynamic-forms or calendar menus, and the backend
    // blocks both endpoints for them - don't fire the requests at all.
    if (String(role).toLowerCase() === "engineer") return undefined;

    fetchDynamicForms();
    fetchCalendarFiles();
    
    // Listen for custom events to refresh
    const handleFormsUpdate = () => fetchDynamicForms();
    const handleFilesUpdate = () => fetchCalendarFiles();
    
    window.addEventListener("dynamicFormsUpdated", handleFormsUpdate);
    window.addEventListener("calendarFilesUpdated", handleFilesUpdate);
    
    return () => {
      window.removeEventListener("dynamicFormsUpdated", handleFormsUpdate);
      window.removeEventListener("calendarFilesUpdated", handleFilesUpdate);
    };
  }, []);

  useEffect(() => {
    const applyMenu = () => {
      const role = getRoleFromStorage();
      setMenu(withFeatureMenus(staticMenu, role));
    };
    window.addEventListener("formErrorLogsVisibilityChanged", applyMenu);
    window.addEventListener("storage", applyMenu);
    return () => {
      window.removeEventListener("formErrorLogsVisibilityChanged", applyMenu);
      window.removeEventListener("storage", applyMenu);
    };
  }, []);
  
  // Handle dropdown toggle
  const handleDropdownClick = (label) => {
    // Prevent event bubbling to avoid interference
    const newDropdownState = openDropdown === label ? '' : label;
    
    // Immediately set the dropdown state - no setTimeout needed
    setOpenDropdown(newDropdownState);
    
    // If Calendar View is being opened, always fetch fresh data
    if (label === 'Calendar View' && newDropdownState === 'Calendar View') {
      const fetchCalendarFiles = async () => {
        try {
          const apiUrl = process.env.REACT_APP_API_URL;
          const baseUrl = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
          const response = await axios.get(
            `${baseUrl}/api/excel-data/calendar/files`,
            {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
              }
            }
          );
          if (response.data.success) {
            const files = response.data.data || [];
            setCalendarFiles(files);
            // Update menu with calendar files
            setMenu(prevMenu => prevMenu.map(item => {
              if (item.isCalendarDataDropdown) {
                return {
                  ...item,
                  subMenu: [
                    // Static Southeastern menu item
                    {
                      icon: "fa-solid fa-bolt",
                      label: "Southeastern",
                      path: "/admin/calendar/Southeastern"
                    },
                    // Static UKPN menu item
                    {
                      icon: "fa-solid fa-hard-hat",
                      label: "UKPN",
                      path: "/admin/calendar/UKPN"
                    },
                    // Dynamic calendar files
                    /* ...(Array.isArray(files) ? files.map(file => {
                      // Clean filename - remove .xlsx extension, year suffixes, and replace spaces with hyphens
                      const originalFileName = file.originalName || file.fileName || '';
                      const cleanFileName = originalFileName
                        .replace(/\.xlsx$/i, '')
                        .replace(/[-_]*\d{4}[-_]*$/, '') // Remove year suffixes like -2025, ---2025, _2025
                        .replace(/\s+/g, '-')
                        .replace(/-+$/, ''); // Remove trailing hyphens
                      
                      return {
                        icon: "fa-solid fa-file-excel",
                        label: file.originalName || file.fileName,
                        path: `/admin/calendar/${cleanFileName}`,
                        badge: `${file.totalRows || 0} rows`
                      };
                    }) : []) */
                  ]
                };
              }
              return item;
            }));
          }
        } catch (error) {
          console.error('Failed to fetch calendar files on dropdown click:', error);
        }
      };
      fetchCalendarFiles();
    }
  };

  // Effect to keep dropdown open when path changes - ONLY for initial page load
  React.useEffect(() => {
    // Only run this effect once on initial load, not on every location change
    const currentDropdown = menu.find(item => 
      item.isDropdown && (
        item.subMenu?.some(subItem => {
          if (subItem.path === location.pathname) return true;
          if (item.isCalendarDataDropdown && location.pathname.includes('/admin/calendar')) return true;
          return false;
        }) ||
        (item.isFormsDropdown && isFormPath(location.pathname)) ||
        location.pathname.startsWith(item.path)
      )
    );
    
    // Only set dropdown on initial load if we found a matching dropdown and none is currently open
    if (currentDropdown && !openDropdown) {
      setOpenDropdown(currentDropdown.label);
    }
  }, []); // Empty dependency array - only run once on mount
  return (
    <>
      <button className="sidebar-mobile-hamburger" onClick={() => setMobileOpen(true)} aria-label="Open sidebar">
        <i className="fa-solid fa-bars"></i>
      </button>
      <aside className={`horizon-sidebar${mobileOpen ? " sidebar-mobile-open" : ""}${collapsed ? " sidebar-collapsed" : ""}`}>
        {/* Mobile close button */}
        <button className="sidebar-mobile-close" style={{display: mobileOpen ? 'block' : 'none'}} onClick={() => setMobileOpen(false)} aria-label="Close sidebar">
          <i className="fa-solid fa-xmark"></i>
        </button>
        <div className="horizon-logo">
          <img src={require('../../assets/onsitepro-logo.png')} alt="OnSitePro Logo" className="logo-img" />
        </div>
        <ul className="horizon-menu">
          {menu.map(item => (
            <li key={item.label} className={`${item.isDropdown ? 'dropdown' : ''} ${location.pathname === item.path ? "active" : ""}`}>
              {item.isDropdown ? (
                <>
                  <button 
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleDropdownClick(item.label);
                    }} 
                    className="horizon-menu-btn dropdown-toggle"
                    aria-expanded={openDropdown === item.label}
                  >
                      <i className={item.icon}></i>
                      <span>{item.label}</span>
                      <i className={`fa-solid fa-chevron-${openDropdown === item.label ? 'up' : 'down'} ms-auto`}></i>
                  </button>
                  <ul className={`submenu ${openDropdown === item.label ? 'show' : ''}`}>
                    {item.isFormsDropdown ? (
                      <li className="forms-submenu-wrapper">
                        <FormsSidebarMenu
                          currentPath={location.pathname}
                          onNavigate={(path) => {
                            navigate(path);
                            if (window.innerWidth <= 768) {
                              setMobileOpen(false);
                            }
                          }}
                        />
                      </li>
                    ) : (
                      <div className="sidebar-forms-scroll">
                        {(item.subMenu || []).map((subItem) => {
                          let isActive = false;
                          if (item.isCalendarDataDropdown) {
                            const currentUrl = location.pathname + location.search;
                            isActive = currentUrl === subItem.path;
                          } else {
                            isActive = location.pathname === subItem.path;
                          }

                          return (
                            <li key={subItem.path || subItem.label} className={isActive ? "active" : ""}>
                              <button
                                onClick={() => {
                                  navigate(subItem.path);
                                  if (window.innerWidth <= 768) {
                                    setMobileOpen(false);
                                  }
                                }}
                                className="horizon-menu-btn"
                              >
                                <i className={subItem.icon}></i>
                                <span data-full-text={subItem.label}>{subItem.label}</span>
                              </button>
                            </li>
                          );
                        })}
                      </div>
                    )}
                  </ul>
                </>
              ) : (
                <button onClick={() => { 
                  // Close any open dropdown when clicking on non-dropdown menu items
                  if (openDropdown) {
                    setOpenDropdown('');
                  }
                  navigate(item.path); 
                  setMobileOpen(false); 
                }} className="horizon-menu-btn">
                  <i className={item.icon}></i>
                  <span>{item.label}</span>
                </button>
              )}
            </li>
          ))}
        </ul>
        {/* <div className="horizon-upgrade">     
           <img src={require('../../assets/onsitepro-logo.png')} alt="OnSitePro Logo" style={{maxWidth:'120px', width:'100%', height:'auto', margin:'0 auto', display:'block'}} />
        </div> */}
      </aside>
      {mobileOpen && <div className="sidebar-mobile-backdrop" onClick={() => setMobileOpen(false)}></div>}
    </>
  );
}
